<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO?rowItem.operatedUserPO.realName :''}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="item">1月：{{form.beforeStr.quotaMap.month_1}}万</div>
          <div class="item">2月：{{form.beforeStr.quotaMap.month_2}}万</div>
          <div class="item">3月：{{form.beforeStr.quotaMap.month_3}}万</div>
          <div class="item">4月：{{form.beforeStr.quotaMap.month_4}}万</div>
          <div class="item">5月：{{form.beforeStr.quotaMap.month_5}}万</div>
          <div class="item">6月：{{form.beforeStr.quotaMap.month_6}}万</div>
          <div class="item">7月：{{form.beforeStr.quotaMap.month_7}}万</div>
          <div class="item">8月：{{form.beforeStr.quotaMap.month_8}}万</div>
          <div class="item">9月：{{form.beforeStr.quotaMap.month_9}}万</div>
          <div class="item">10月：{{form.beforeStr.quotaMap.month_10}}万</div>
          <div class="item">11月：{{form.beforeStr.quotaMap.month_11}}万</div>
          <div class="item">12月：{{form.beforeStr.quotaMap.month_12}}万</div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="item">1月：{{form.afterStr.quotaMap.month_1}}万</div>
          <div class="item">2月：{{form.afterStr.quotaMap.month_2}}万</div>
          <div class="item">3月：{{form.afterStr.quotaMap.month_3}}万</div>
          <div class="item">4月：{{form.afterStr.quotaMap.month_4}}万</div>
          <div class="item">5月：{{form.afterStr.quotaMap.month_5}}万</div>
          <div class="item">6月：{{form.afterStr.quotaMap.month_6}}万</div>
          <div class="item">7月：{{form.afterStr.quotaMap.month_7}}万</div>
          <div class="item">8月：{{form.afterStr.quotaMap.month_8}}万</div>
          <div class="item">9月：{{form.afterStr.quotaMap.month_9}}万</div>
          <div class="item">10月：{{form.afterStr.quotaMap.month_10}}万</div>
          <div class="item">11月：{{form.afterStr.quotaMap.month_11}}万</div>
          <div class="item">12月：{{form.afterStr.quotaMap.month_12}}万</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
